module.exports = __webpack_public_path__ + "static/img/mermaidFishing.d309eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/mermaidFishing.png
// module id = whnJ
// module chunks = 0